import React, { useCallback } from 'react';
import classNames from '~/components/util/classNames';


const Card = ({className = '', shadow, children, ...props}) => {

    const getShadow = useCallback(() => {
        if (shadow == 'none' || className.includes('drop-shadow')) {
            return '';
        } else if (shadow) {
            return `filter drop-shadow-${shadow}`;
        } else {
            return 'filter drop-shadow-2xl';
        }
    }, [shadow]);

    return (
        <div className={classNames(className, 'bg-white', getShadow())} {...props}>
            {children}
        </div>
    );
};

export default Card;